import React from 'react';
import '../styles/Hero.css';
import { FaPhone, FaArrowDown } from 'react-icons/fa';

const Hero = () => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="geometric-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Strong foundations,<br />
              <span className="highlight">stronger trust.</span>
            </h1>
            <p className="hero-subtitle">
              Expert construction services in San Marcos, Texas. 
              From masonry to landscaping, we build with excellence and integrity.
            </p>
            <div className="hero-buttons">
              <a href="tel:512-648-9102" className="btn btn-primary">
                <FaPhone /> Get Free Estimate
              </a>
              <button onClick={scrollToServices} className="btn btn-secondary">
                View Services
              </button>
            </div>
          </div>
          
          <div className="hero-image">
            {/* NOTA: Aquí puedes agregar una imagen de construcción o el logo grande */}
            <div className="hero-logo-container">
              <img 
                src="/logo-large.svg" 
                alt="M502 Construction" 
                className="hero-logo"
              />
              <div className="floating-shapes">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="scroll-indicator" onClick={scrollToServices}>
          <FaArrowDown className="scroll-arrow" />
        </div>
      </div>
    </section>
  );
};

export default Hero;